"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureEnabled = void 0;
const tslib_1 = require("tslib");
const get_1 = tslib_1.__importDefault(require("lodash/get"));
/**
 * Return true if feature should be enabled as per config
 *
 * @param {object} config
 * @param {string} featureId
 * @returns {bool}
 */
const isFeatureEnabled = (config, featureId) => {
    return (0, get_1.default)(config, featureId) === 1;
};
exports.isFeatureEnabled = isFeatureEnabled;
exports.default = exports.isFeatureEnabled;
//# sourceMappingURL=isFeatureEnabled.js.map